module.exports = __webpack_public_path__ + "static/media/5.Water level controller.50b7923e.jpg";